import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { closeModel } from "../../assets/Js/closeModel";
import { openModel } from "../../assets/Js/openModel";

const modalId = "messageModal";

export default function Popup({
  title,
  children,
  icon,
  saveBtnTxt,
  closeBtnTxt,
  showModal,
  showCloseBtn,
  showSaveBtn,
  closeBtnStyle,
  saveBtnStyle,
}) {
  const [displayModal, setDisplayModal] = useState(showModal);

  const handleSave = () => {
    closeModel(modalId);
    setDisplayModal(false);
  };
  const handleClose = () => {
    closeModel(modalId);
    setDisplayModal(false);
  };
  useEffect(() => {
    if (displayModal === true) {
      openModel(modalId);
      setDisplayModal(true);
    } else {
      closeModel(modalId);
      setDisplayModal(false);
    }
  }, [displayModal]);

  return (
    <>
      {displayModal && (
        <>
          <div
            className="modal fade"
            id={modalId}
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div
              className="modal-dialog  modal-dialog-centered"
              role="document"
            >
              <div className="modal-content">
                <div>
                  <button
                    type="button"
                    class="close"
                    onClick={handleClose}
                    aria-hidden="true"
                    data-dismiss="modal"
                    aria-label="Close"
                    on
                    style={{
                      display: "flex",
                      alignItems: "flex-end",
                      margin: " 10px 10px 0px 0px",
                    }}
                  >
                    <span aria-hidden="true" class="mdi mdi-close"></span>
                  </button>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    padding: "0px 19px",
                  }}
                >
                  <img
                    src={icon}
                    alt="ticksvg"
                    style={{
                      width: "57px",
                      height: "57px",
                      color: "#13c39c",
                    }}
                  />
                  <h5
                    className="modal-title"
                    id="exampleModalLabel"
                    style={{ margin: "10px" ,textAlign:"center" }}
                  >
                    {title}
                  </h5>
                </div>
                <div className="modal-footer" style={{justifyContent: "center"}}>
                  {children}
                </div>
                {showCloseBtn && (
                  <div className="modal-footer">
                    {showCloseBtn && (
                      <button
                        type="button"
                        className={`btn btn-secondary ${closeBtnStyle}`}
                        data-dismiss="modal"
                        onClick={handleClose}
                      >
                        {(closeBtnTxt = "Close")}
                      </button>
                    )}
                    {showSaveBtn && (
                      <button
                        type="button"
                        className={`btn btn-primary ${saveBtnStyle}`}
                        onClick={handleSave}
                      >
                        {(saveBtnTxt = "OK")}
                      </button>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

Popup.propTypes = {
  title: PropTypes.string,
  children: PropTypes.element,
  saveBtnTxt: PropTypes.string,
  closeBtnTxt: PropTypes.string,
  showModal: PropTypes.bool,
  showCloseBtn: PropTypes.bool,
  showSaveBtn: PropTypes.bool,
  handleClose: PropTypes.func,
  handleSave: PropTypes.func,
  closeBtnStyle: PropTypes.string,
  saveBtnStyle: PropTypes.string,
};
